import { NotFoundErrorCode, ValidationErrorCode } from '@today/types'
import { isAxiosError } from 'axios'

interface ApiErrorBody {
	error?: { code?: string; details?: { field?: string; fields?: string[] } }
}

/** A refused request's error code and details, or an empty object for anything else. */
export const apiErrorOf = (error: unknown): { code?: string; field?: string; fields?: string[] } => {
	const body = isAxiosError<ApiErrorBody>(error) ? error.response?.data?.error : undefined
	return { code: body?.code, field: body?.details?.field, fields: body?.details?.fields }
}

/** The preview pane's message for a refused template preview (TO-140 Contract, preview route). */
export const templatePreviewErrorOf = (error: unknown): string => {
	const { code, field } = apiErrorOf(error)
	switch (code) {
		case ValidationErrorCode.NOTIFICATION_TEMPLATE_SYNTAX_INVALID:
			return `The ${field ?? 'body'} is not valid Liquid.`
		case ValidationErrorCode.NOTIFICATION_TEMPLATE_RENDER_FAILED:
			return 'The message could not be rendered for this offer.'
		case NotFoundErrorCode.OFFER_NOT_FOUND:
			return 'This offer could not be found.'
		default:
			return 'The preview could not be rendered.'
	}
}
